<template>
  <form @submit.prevent="submit" class="form">
    <div class="form-group form-row">
      <div class="col-xs-12 col-sm-6 col-md-6 col-xl-6">
        <input type="text" v-model="firstname"
               maxlength="30" class="form-control"
               placeholder="Vorname"
               required autofocus
               aria-label="Vorname"/>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-xl-6">
        <input type="text" v-model="lastname"
               maxlength="30" class="form-control"
               placeholder="Nachname"
               required autofocus
               aria-label="Nachname"/>
      </div>
    </div>
    <div class="form-group form-row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
        <input type="text" v-model="street"
               maxlength="80" class="form-control"
               placeholder="Straße, Nr"
               required autofocus
               aria-label="Straße, Nr"/>
      </div>
    </div>
    <div class="form-group form-row justify-content-sm-center">
      <div class="col-xs-12 col-sm-4 col-md-4 col-xl-4">
        <input type="text" v-model="zipcode"
               maxlength="10" class="form-control"
               placeholder="PLZ"
               required autofocus
               aria-label="PLZ"/>
      </div>
      <div class="col-xs-12 col-sm-8 col-md-8 col-xl-8">
        <input type="text" v-model="city"
               maxlength="30" class="form-control"
               placeholder="Stadt"
               required autofocus
               aria-label="Stadt"/>
      </div>
    </div>
    <div class="form-group form-row justify-content-sm-center">
      <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
        <input type="text" v-model="country"
               maxlength="30" class="form-control"
               placeholder="Land (optional)"
               autofocus
               aria-label="Land (optional)"/>
      </div>
    </div>
    <div class="form-group form-row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
        <input type="text" v-model="email"
               maxlength="50" class="form-control"
               placeholder="E-Mail (für Rückfragen)"
               required autofocus
               aria-label="E-Mail (für Rückfragen)"/>
      </div>
    </div>
    <div class="form-group form-row justify-content-sm-center">
      <div class="col-xs-12 col-sm-auto text-center text-sm-left">
        <button class="btn btn-primary btn-submit" type="submit" :disabled="loading">
          <span>Abschicken</span>
        </button>
      </div>
    </div>

    <small id="gdpr-notice"
           class="form-text text-muted">
      Durch Abschicken dieses Formulars stimmen Sie der Speicherung und Verarbeitung Ihrer Daten gemäß unserer
      <a href="https://www.animod.de/c/datenschutz" target="_blank" rel="noopener">
        Datenschutzerklärung
      </a> zu.
    </small>
  </form>
</template>

<script>
export default {
  name: 'ShippingAddressForm',
  components: {},
  props: {
    loading: Boolean,
    code: String,
    payload: String
  },
  data() {
    return {
      email: "",
      firstname: "",
      lastname: "",
      street: "",
      zipcode: "",
      city: "",
      country: ""
    };
  },
  computed: {},
  methods: {
    submit() {
      this.$emit('submit', {
        firstname: this.firstname,
        lastname: this.lastname,
        street: this.street,
        zipcode: this.zipcode,
        city: this.city,
        country: this.country,
        email: this.email,
        code: this.code,
        payload: this.payload
      });
    }
  }
}
</script>

<style scoped lang="scss">
@import "~bootstrap/scss/_functions.scss";
@import "~bootstrap/scss/_variables.scss";
@import "~bootstrap/scss/mixins/breakpoints";

$primary-color: hsl(25, 100%, 60%);

.form {
  .btn-submit {
    @include media-breakpoint-down(xs) {
      display: block;
      margin: 1.25rem auto 0;
    }
  }

  a:not(.btn-primary) {
    color: $primary-color;
  }

  .btn-primary {
    background-color: $primary-color;
    background-image: linear-gradient(180deg, hsl(25, 100%, 65%), hsl(25, 100%, 60%));
    border: none;
    box-shadow: 0 0.0625rem 0.1875rem 0 rgba(0, 0, 0, .2);
    color: hsl(0, 0%, 100%);
    font-weight: 700;
    letter-spacing: .0625rem;
    text-transform: uppercase;
  }
}
</style>
